<template>
    <div>
        <h4 class="title__name">Live In-Play</h4>
        <div class="horizontal-scroller">
            <div v-for="(item,index) in sports" :key="index" class="sport-item" @click="setSport(item.sport)" :class="{'selectedSport': selectedSport===item.sport }">
                <div class="sport-icon-container">
                    <v-badge color="#8064E7" overlap class="badge-container">
                        <template v-slot:badge>
                            <span class="badge-counter">{{ sportCount[item.sport] || 0 }}</span>
                        </template>
                        <img :src="getSportIconPath(item.sport)" :alt="item.sport" class="sport-icon">
                    </v-badge>
                </div>
                <span class="sport-name">{{ item.sport.replace(/([A-Z])/g, ' $1').trim() }}</span>
            </div>
        </div>
    </div>
</template>
<script>
    import { HubConnection } from "@aspnet/signalr";
    import BetOptions from './BetOptions.vue';
    import SportsApi from '../api/sportFixtures';
    import * as CONFIG from "../config";

    export default {
        name: "Sports",
        components: {
            BetOptions
        },
        props: {
            connection: HubConnection,
            sportCount: Object,
        },
        data() {
            return {
                sports: [],
                selectedSport: null,
                right: null,
                dark: CONFIG.DARK_MODE
            }
        },
        mounted() {
            SportsApi.getSportFixtures()
                .then(data => {
                    data.responseObject.unshift({sport: "All Sports"});
                    this.selectedSport = data && data.responseObject && data.responseObject[0] && data.responseObject[0].sport;
                    this.$emit('setSport', this.selectedSport);

                    for (var i = 0; i < data.responseObject.length; i++) {
                            this.sports.push(data.responseObject[i]);
                    }
                })
                .catch((err) => console.log(err))
                .then(() => {
                    this.connection.start()
                        .then(() => {
                            if (this.selectedSport === 'All Sports') {
                                this.sports.forEach((item, index) => {
                                    if (index === 0){
                                        return;
                                    }
                                    this.connection.invoke("Subscribe", item.sport + "match_winner");
                                    this.connection.invoke("Subscribe", item.sport + "match_summary");
                                });
                            }
                            else{
                                this.connection.invoke("Subscribe", this.selectedSport + "match_winner");
                                this.connection.invoke("Subscribe", this.selectedSport + "match_summary");
                            }
                            this.connection.invoke("Subscribe", "sport_update");
                        })
                        .catch((err) => {
                            console.log(err)
                        });
                })
                .catch((err) => {
                    console.log(err);
                })
                .then(() => {
                    this.connection.on("su-rcv", (value) => {
                        if (value !== null) {
                            this.updateSport(JSON.parse(value));
                        }
                    });
                })
                .catch((err) => {
                    console.log(err)
                });

        },
        methods: {            
            sportContains(image) {
                return image.indexOf(image) >= -1
            },
            getSportIconPath(sportName) {
                if (sportName) {
                    if (this.sportContains(sportName)) {
                        const svgName = sportName.replace(/\s/g, '-').toLowerCase();
                        
                        if(this.dark)
                        {
                            return require(`../assets/img/icons/${svgName}-dark.svg`);
                        }else
                        {
                            return require(`../assets/img/icons/${svgName}.svg`);
                        }
                    }
                }

            },
            setSport(sport) {
                if (this.selectedSport === 'All Sports') {
                    this.sports.forEach((item, index) => {
                        if (index === 0){
                            return;
                        }
                        this.connection.invoke("UnSubscribe", item.sport + "match_winner");
                        this.connection.invoke("UnSubscribe", item.sport + "match_summary");
                    });
                }
                else {
                    this.connection.invoke("UnSubscribe", this.selectedSport + "match_winner");
                    this.connection.invoke("UnSubscribe", this.selectedSport + "match_summary");
                }

                this.selectedSport = sport;
                this.$emit('setSport', sport);

                if (sport === 'All Sports') {
                    this.sports.forEach((item, index) => {
                        if (index === 0){
                            return;
                        }
                        this.connection.invoke("Subscribe", item.sport + "match_winner");
                        this.connection.invoke("Subscribe", item.sport + "match_summary");
                    });
                }
                else {
                    this.connection.invoke("Subscribe", this.selectedSport + "match_winner");
                    this.connection.invoke("Subscribe", this.selectedSport + "match_summary");
                }
            },
            updateSport(updatedSport) {
                if (this.sports !== updatedSport) {
                    this.sports = this.mergeSport(this.sports, updatedSport);
                }
            },

            mergeSport(api, signalR) {
                let temp = api.map(s => s.sport);
                for (let item in signalR) {
                        let value = signalR[item].Sport;
                        if (temp.indexOf(value) === -1)
                            api.push({ sport: value })
                }
                return api
            },
        },
    }
</script>
<style>
    /* .selectedSport {
        border-bottom: #4f2e7b 2px solid;
    } */

    .selectedSport {
        border-bottom: #8064E7 2px solid;
    }

    .selectedSport .v-list__tile__action {
        background-color: #2b2b2b !important;
    }

    .selectedSport .v-list__tile__avatar {
        background-color: #360d64;
    }

    .horizontal-scroller {
        display: flex;
        overflow-x: auto;
        padding: 10px 5px;
        border-bottom: 1px solid #dddddd;
    }

    .sport-item {
        margin-right: 30px; 
        display: flex;
        flex-direction: column;
        align-items: center; 
        cursor: pointer;
        transition: transform 0.2s; 
    }

    .sport-item:hover {
        transform: scale(1.1); 
    }

    .sport-icon-container {
        position: relative; 
    }

    .sport-icon {
        width: 30px; 
        margin-bottom: 0px; 
    }

    .sport-name {
        font: normal normal medium 14px/21px Poppins;
        margin-top: 5px; 
        text-align: center; 
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 65px;
        color: #808191;
    }

   

    .badge-container {
        position: relative; 
        top: 5px; 
        right: 0; 
    }

    .badge-counter {
        font-size: 12px;
    }

    .v-badge--overlap {
        position: relative;
    }

    .title__name {
        font-size: 16px;
        font-weight: 300;
        text-transform: uppercase;
        padding: 7px;
        color: #fff;
        border: 0;
        margin-bottom: 0;
        background: url('../assets/img/title-star-new.png') no-repeat center left;
        padding-left: 40px;
        background-color: #8064E7;
    }

    @media (max-width: 480px) {
        .title__name {
            text-align: left;
        }
    }

    .full-height {
        overflow-x: hidden;
        overflow-y: auto;
        height: 100vh;
    }

        .full-height::-webkit-scrollbar-track {
            -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);
            background-color: #aaa;
        }

        .full-height::-webkit-scrollbar {
            width: 10px;
            background-color: #d3d3d3;
        }

        .full-height::-webkit-scrollbar-thumb {
            background-color: #440f6e;
            border: 2px solid #440f6e;
        }

    .v-card.v-card--flat.v-sheet.theme--dark.grey.darken-3.full-height {
        background: #0a0a0a !important;
    }

    @media (max-width:960px) {
        .v-btn__content {
            white-space: pre-wrap !important;
            width: 100% !important;
        }

        .full-height {
            height: 100% !important;
        }
    }
</style>